import 'date-fns';
import * as dotProp from 'dot-prop';
import React, {useContext, useEffect, useState} from 'react';
import {ITextField} from '../../../../CommonInterfaces/Form';
import {AdminOrSpecialCoordinatorElement} from '../../../auth/AdminOrSpecialCoordinatorElement';
import {UserContext} from '../../../auth/UserContext';
import {FormHeading} from '../../../Typography/FormHeading';
import {FullWidthDivider} from '../../../Typography/FullWidthDivider';
import {getFieldProps} from '../../Helpers';
import {UniversalInputBuilder} from './UniversalInputBuilder';

/**
 * Build text field with Formik.
 * @param {any} formik
 * @param {string} name
 * @param {string} title
 * @param {string | undefined} type
 * @param onChange
 * @param child
 * @param parent
 * @param nullable
 * @param disabled
 * @param minimum_access
 * @constructor
 */
export default function UniversalInput({
  formik,
  name,
  title = '',
  type = undefined,
  onChange,
  child,
  parent,
  nullable,
  disabled = false,
  minimum_access,
}: ITextField) {
  const {currentUser} = useContext(UserContext);

  // District
  const [currentDistrict, setCurrentDistrict] = useState<string | undefined>();//TODO: refactor

  useEffect(() => {
    // For user_district_school type, get district_id from authenticated user
    if (type === 'user_district_school') {
      setCurrentDistrict(String(currentUser.district_id));
    } else {
      setCurrentDistrict(
        dotProp.get(formik.values, parent ? parent : 'district.id'));
    }
  }, [formik, type, currentUser.district_id]);

  if (type === 'caption' && !name) {
    return (
      <FormHeading title={title}/>
    );
  }
  if (type === 'divider') {
    return (
      <FullWidthDivider/>
    );
  }
  if (!name) {
    return (
      <span>
        name property required
      </span>
    );
  }
  const {dotValue, dotErrors, dotTouched} = getFieldProps({formik, name});

  const input = <UniversalInputBuilder
    title={title}
    formik={formik}
    name={name}
    currentDistrict={currentDistrict}
    dotErrors={dotErrors}
    dotTouched={dotTouched}
    dotValue={dotValue}
    minimum_access={minimum_access}
    disabled={disabled}
    nullable={nullable}
    parent={parent}
    child={child}
    onChange={onChange}
    type={type}
  />;
  if (minimum_access) {
    return (
      <AdminOrSpecialCoordinatorElement accessLevel={minimum_access}>
        {input}
      </AdminOrSpecialCoordinatorElement>
    );
  } else {
    return input;
  }

}
